import { render, staticRenderFns } from "./PracticeNotesIcon.vue?vue&type=template&id=19694cbd&scoped=true"
import script from "./PracticeNotesIcon.vue?vue&type=script&lang=ts"
export * from "./PracticeNotesIcon.vue?vue&type=script&lang=ts"
import style0 from "./PracticeNotesIcon.vue?vue&type=style&index=0&id=19694cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19694cbd",
  null
  
)

export default component.exports